<template>

<div class="tickContainer"><div class="tick"></div></div>
<div class="tickContainer" id="tick2"><div class="tick" ></div></div>
<div class="tickContainer" id="tick3"><div class="tick" ></div></div>
<div class="tickContainer" id="tick4"><div class="tick" ></div></div>
<div class="tickContainer" id="tick5"><div class="tick" ></div></div>
<div class="tickContainer" id="tick6"><div class="tick" ></div></div>
    
</template>

<style lang="scss" scoped>


.tickContainer {
  position:absolute;
  height:130px;
  z-index:1000;
  
}

.tickContainer {
  animation: tick-spin 6s cubic-bezier(0.5, 0, 0.5, 1) infinite;

}


.tick {
  width:10px;
  height:10px;
  border-radius: 50%;
  background-color:$orange1;
  opacity:0.4;
}

#tick2 {
   animation-delay: 0.2s;
}
#tick3 {
   animation-delay: 0.4s;
}
#tick4 {
   animation-delay: 0.6s;
}
#tick5 {
   animation-delay: 0.8s;
}
#tick6 {
   animation-delay: 1.0s;
}


@keyframes tick-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>